module.exports = __webpack_public_path__ + "static/media/coming-soon.3a144521.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/coming-soon.png
 ** module id = 1612
 ** module chunks = 0
 **/